var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("h5", { staticClass: "text-h5 q-mt-lg q-mb-md" }, [
            _vm._v(_vm._s(_vm.$t(_vm.game_data.game_name)))
          ]),
          _c(
            "q-collapsible",
            {
              staticClass: "shadow-2 q-pa-sm q-ma-xs rounded-border",
              attrs: {
                icon: "far fa-ballot-check",
                "right-icon": "far fa-ballot-check",
                label: _vm.$t("how_to_create_the_game")
              }
            },
            [
              _c("div", { staticClass: "q-ma-sm" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("enigma_instructions")))]),
                _c("p", { staticClass: "q-mt-lg" }, [
                  _c("em", [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("warning") + ": "))]),
                    _vm._v(_vm._s(_vm.$t("create_game_before_save")))
                  ])
                ])
              ])
            ]
          ),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 q-mb-md" }, [
              _c("div", { staticClass: "row gutter-sm" }, [
                _vm.game_data.options.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      _vm._l(_vm.game_data.options, function(option, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c(
                              "q-list",
                              {
                                staticClass: "q-mt-lg",
                                attrs: {
                                  dense: "",
                                  bordered: "",
                                  padding: "",
                                  separator: ""
                                }
                              },
                              [
                                _c(
                                  "q-item",
                                  [
                                    _c(
                                      "q-item-main",
                                      { staticClass: "q-mx-sm q-mt-sm" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "row justify-between"
                                          },
                                          [
                                            _c("q-item-main", {
                                              attrs: {
                                                label:
                                                  _vm.$t("enigma") +
                                                  " " +
                                                  (index + 1)
                                              }
                                            }),
                                            _c(
                                              "q-item-main",
                                              [
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.game_data.options
                                                            .length > 2,
                                                        expression:
                                                          "game_data.options.length > 2"
                                                      }
                                                    ],
                                                    attrs: {
                                                      dense: "",
                                                      outline: "",
                                                      color: "negative",
                                                      size: "md"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeRiddle(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("remove")
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("q-tooltip", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "remove_enigma"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "q-btn",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      option.tips.length < 3,
                                                    expression:
                                                      "option.tips.length < 3"
                                                  }
                                                ],
                                                attrs: {
                                                  dense: "",
                                                  outline: "",
                                                  round: "",
                                                  icon: "fas fa-plus",
                                                  size: "md"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.addTip(index)
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-tooltip", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t("add_tip")
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._l(option.tips, function(
                                          tip,
                                          tipIdx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: tipIdx,
                                              staticClass:
                                                "row justify-center items-center"
                                            },
                                            [
                                              _c(
                                                "q-field",
                                                {
                                                  staticClass: "col-11",
                                                  attrs: { count: 120 }
                                                },
                                                [
                                                  _c("q-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: "2",
                                                      "max-height": 120,
                                                      "float-label": _vm.$t(
                                                        "tip"
                                                      ),
                                                      error:
                                                        _vm.$v.game_data.options
                                                          .$each[index].tips
                                                          .$each[tipIdx].label
                                                          .$error
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        _vm.game_built
                                                          ? _vm.resetGame()
                                                          : null
                                                      },
                                                      input: function($event) {
                                                        _vm.$v.game_data.options
                                                          .$each[index].tips
                                                          .$each[tipIdx].label
                                                          .$touch
                                                      }
                                                    },
                                                    model: {
                                                      value: tip.label,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          tip,
                                                          "label",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "tip.label"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-center q-pl-lg"
                                                },
                                                [
                                                  option.tips.length > 2
                                                    ? _c(
                                                        "q-btn",
                                                        {
                                                          attrs: {
                                                            round: "",
                                                            outline: "",
                                                            color: "negative",
                                                            icon: "fal fa-trash"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeTip(
                                                                index,
                                                                tipIdx
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-tooltip", [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "remove_tip"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _c("q-item-separator", {
                                  attrs: { inset: "" }
                                }),
                                _c(
                                  "q-item",
                                  {
                                    staticClass: "column col-12 q-mx-sm q-mt-sm"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "full-width row justify-between"
                                      },
                                      [
                                        _c("small", [
                                          _vm._v(_vm._s(_vm.$t("alternatives")))
                                        ]),
                                        _c(
                                          "q-btn",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  option.alternatives.length <
                                                  5,
                                                expression:
                                                  "option.alternatives.length < 5"
                                              }
                                            ],
                                            attrs: {
                                              dense: "",
                                              outline: "",
                                              round: "",
                                              icon: "fas fa-plus",
                                              size: "md"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.addAlternative(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t("add_alternative")
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "full-width row justify-start q-mt-md"
                                      },
                                      _vm._l(option.alternatives, function(
                                        alternative,
                                        altIdx
                                      ) {
                                        return _c(
                                          "q-field",
                                          {
                                            key: altIdx,
                                            staticClass:
                                              "col-xs-12 col-md-4 col-4 q-px-lg q-pt-md",
                                            attrs: { count: 50 }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row justify-between items-center"
                                              },
                                              [
                                                _c(
                                                  "q-item-side",
                                                  [
                                                    _c("q-radio", {
                                                      attrs: {
                                                        val: alternative.value,
                                                        color:
                                                          option.correct_choice ===
                                                          alternative.value
                                                            ? "positive"
                                                            : "",
                                                        size: "md",
                                                        label: _vm.$t("correct")
                                                      },
                                                      model: {
                                                        value:
                                                          option.correct_choice,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            option,
                                                            "correct_choice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "option.correct_choice"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "q-item-side",
                                                  { attrs: { right: "" } },
                                                  [
                                                    option.alternatives.length >
                                                    3
                                                      ? _c(
                                                          "q-btn",
                                                          {
                                                            attrs: {
                                                              round: "",
                                                              outline: "",
                                                              dense: "",
                                                              color: "negative",
                                                              icon:
                                                                "fal fa-trash"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeAlternative(
                                                                  index,
                                                                  altIdx
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("q-tooltip", [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "remove_alternative"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c("q-input", {
                                              attrs: {
                                                type: "text",
                                                rows: "2",
                                                "float-label":
                                                  _vm.$t("alternative") +
                                                  " " +
                                                  (altIdx + 1),
                                                error:
                                                  _vm.$v.game_data.options
                                                    .$each[index].alternatives
                                                    .$each[altIdx].label.$error
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.game_built
                                                    ? _vm.resetGame()
                                                    : null
                                                },
                                                input: function($event) {
                                                  _vm.$v.game_data.options
                                                    .$each[index].alternatives
                                                    .$each[altIdx].label.$touch
                                                }
                                              },
                                              model: {
                                                value: alternative.label,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    alternative,
                                                    "label",
                                                    $$v
                                                  )
                                                },
                                                expression: "alternative.label"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-xs-12 q-mt-sm q-mx-xs" },
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          helper: _vm.$t(
                            "leave_it_blank_or_negative_to_use_infinite"
                          )
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: {
                            type: "number",
                            "float-label": _vm.$t("alternative_error_limit")
                          },
                          on: {
                            change: function($event) {
                              _vm.game_built ? _vm.resetGame() : null
                            }
                          },
                          model: {
                            value: _vm.game_data.max_errors,
                            callback: function($$v) {
                              _vm.$set(_vm.game_data, "max_errors", $$v)
                            },
                            expression: "game_data.max_errors"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "full-width row justify-end q-mr-md q-mt-md" },
                  [
                    _c(
                      "q-btn",
                      {
                        staticClass: "q-mr-md",
                        attrs: {
                          color: "primary",
                          icon: "far fa-plus",
                          label: _vm.$t("add"),
                          disable: _vm.game_data.options.length > 9
                        },
                        on: { click: _vm.addRiddle }
                      },
                      [
                        _c("q-tooltip", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("add_enigma")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "q-btn",
                      {
                        attrs: {
                          color: "secondary",
                          label: _vm.$t("preview"),
                          disable: _vm.disableGamePreview
                        },
                        on: { click: _vm.buildGamePreview }
                      },
                      [
                        _c("q-tooltip", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("preview_game")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm.show_game_preview
        ? _c("enigma-preview", {
            attrs: {
              show_game_preview: _vm.show_game_preview,
              game_name: _vm.game_data.game_name,
              game_options: _vm.game_data.options,
              game_max_errors: _vm.game_data.max_errors
            },
            on: {
              hide_preview: function($event) {
                return _vm.hidePreview()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }